import React from 'react';
import { useTranslation } from 'react-i18next';

import map_globe from '@/assets/figma/map_globe.png'

const getDevices = (t: (key: string) => string) => [
  { name: t('earning-device-desktop'), img: 'device_1.png', price: '500$' },
  { name: t('earning-device-laptop'), img: 'device_3.png', price: '1500$' },
  { name: t('earning-device-server'), img: 'device_2.png', price: '5000$' },
];

export const Earning: React.FC = () => {
  const { t } = useTranslation();
  const devices = getDevices(t);

  return (
    <section className="section-page relative overflow-hidden">
      <div className="max-w-7xl mx-auto">

        {/* 3 devices */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-10 lg:gap-12 max-w-5xl mx-auto">
          {devices.map((d, i) => (
            <div key={i} className="flex flex-col items-center text-center group">
              <div className="relative mb-6 h-[min(12rem,42vw)] w-[min(12rem,42vw)] overflow-hidden rounded-full border border-white/10 bg-black transition-transform duration-500 ease-out group-hover:scale-[1.02] sm:h-56 sm:w-56">
                <img
                  src={new URL(`../assets/figma/${d.img}`, import.meta.url).href}
                  alt={d.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="mb-2 text-lg text-white sm:text-xl">{d.name}</p>
              <p className="text-sm text-[#939393] sm:text-base">{t('earning-annual-income')}</p>
              <p className="my-1 font-normal tabular-nums text-3xl text-white md:text-4xl">{d.price}</p>
            </div>
          ))}
        </div>
        {/* Map/Globe */}
        <div className="relative rounded-2xl overflow-hidden my-12 md:pl-20 md:pt-14 px-6 pt-6" style={{
          backgroundImage: `url(${map_globe})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        }}>
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 lg:gap-16 items-center">
            {/* Left text */}
            <div className="order-1 md:order-1">
              <h2 className="mb-4 text-balance text-3xl text-white">
                {t('earning-title')}
              </h2>
              <p className="mb-6 text-pretty font-semibold leading-relaxed text-white text-lg sm:text-xl">
                {t('earning-highlight')}
              </p>
              <p className="text-pretty text-base leading-relaxed text-white/90">
                {t('earning-description')}
              </p>
            </div>

            {/* Right phone */}
            <div className="order-2 md:order-2 flex justify-center">
              <img
                src={new URL('../assets/figma/phone_mockup.png', import.meta.url).href}
                alt="HybridNodes App"
                className="w-[min(22rem,88vw)] sm:w-80 md:w-80 max-w-full drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
